import { createFileRoute, useRouter } from "@tanstack/react-router";

import { ProfileDetailsPageConnector } from "@pages/profile-details";

export const Route = createFileRoute("/_private/profile-details")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  return <ProfileDetailsPageConnector onBack={router.history.back} />;
}
